const baseGeneralUrl = "General"
const baseAdvertUrl = "Advert"

  const endpoints = {
    getFavoriteListFilter:`${baseGeneralUrl}/GetFavoriteList`,
    addFavoriteListItem:`${baseGeneralUrl}/AddFavoriteList`,
    updateFavoriteListItem:`${baseGeneralUrl}/EditFavoriteList`,
    deleteFavoriteListItem:`${baseGeneralUrl}/DeleteFavoriteList`,
    getFavoriteAdvertList:`${baseGeneralUrl}/GetFavoriteListById`,
    addFavoriteAdvert:`${baseAdvertUrl}/AddFavoriteByAdvert`,
    deleteFavoriteAdvert:`${baseAdvertUrl}/DeleteFavoriteByAdvert`,
    resetAllItemsOnFavoriteList:`${baseGeneralUrl}/DeleteAllFavoriteByFavoriteList`,
    getPriceHistoryByAdvert:`${baseAdvertUrl}/GetPriceHistoryByAdvert`,

    
  };
  
  export default endpoints;
  